import type { GameManual } from '../../types';
import { spiritIslandChapters, spiritIslandFirstGame } from './content';

export const spiritIslandManual: GameManual = {
  chapters: spiritIslandChapters,
  firstGameSteps: spiritIslandFirstGame,
  addons: [
  {
    "id": "branch-and-claw",
    "name": "Zarośla i Szpony"
  },
  {
    "id": "jagged-earth",
    "name": "Rozdarta Ziemia"
  },
  {
    "id": "feather-and-flame",
    "name": "Pióra i Płomienie"
  }
],
};

export * from './content';
export * from './faq';
export * from './glossary';
export * from './guided';
export * from './quickReference';
export * from './commonMistakes';
export * from './scoring';
export * from './components';
export * from './icons';
export * from './search';
export * from './validate';
